
















import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { Follower } from "@scrile/api-provider/dist/api/FollowingsProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import AvatarDescription from "@/components/AvatarDescription";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "FollowingItem",
  components: { AvatarDescription, BaseButton },
  props: {
    following: { type: Object as PropType<Follower>, required: true },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const update = () => {
      loading.value = true;
      emit("update", {
        following: props.following,
        cb: () => {
          loading.value = false;
        },
      });
    };

    const profileUrl = computed(() => getProfileUrl(props.following.userId));

    return { loading, update, profileUrl };
  },
});
